import { CompanyType } from 'app/constants/companyType'

/**
 * Nazwa ikony `AdminIcon` dla typu firmy.
 *
 * Wcześniej zwracało ścieżkę do zielonego SVG z paczki nucleo (`mix/company.svg`) -
 * zieleń `#4FBE97` była kolorem starej marki. Teraz to nazwa ikony Font Awesome,
 * rysowanej w kolorze motywu.
 */
export const getCompanyTypeIcon = (
  type: CompanyType,
  isAccounting: boolean = false,
) => {
  if (isAccounting) {
    return 'accounting'
  }

  return type === CompanyType.SERVICE ? 'company-group' : 'company'
}
